import { render, staticRenderFns } from "./LandingFeaturesCoverItem.vue?vue&type=template&id=adb68c7e&scoped=true"
import script from "./LandingFeaturesCoverItem.vue?vue&type=script&lang=js"
export * from "./LandingFeaturesCoverItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb68c7e",
  null
  
)

export default component.exports